export default __webpack_public_path__ + "static/media/006-pompom-white.dbcfb0b0.svg";